import { CLAIM_STATUSES } from '../../api/constants';

const BadgeStatus = ({ status }) => {
  if (status <= 0) {
    return;
  }

  return (
    <span
      className={`badge ${
        status == CLAIM_STATUSES.APPROVED
          ? 'bg-primary'
          : status == CLAIM_STATUSES.PACKED
          ? 'bg-success'
          : status == CLAIM_STATUSES.DRAFT
          ? 'bg-secondary'
          : status.includes(CLAIM_STATUSES.PENDING)
          ? 'bg-warning'
          : status == CLAIM_STATUSES.PICKING
          ? 'bg-info'
          : status == CLAIM_STATUSES.REJECTED
          ? 'bg-danger-custom'
          : 'bg-dark '
      } `}
      style={{
        fontSize: 12,
        fontWeight: 500,
        padding: '6px 8px',
        display: 'inline-block',
      }}
    >
      {status}
    </span>
  );
};

export default BadgeStatus;
